module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAPCAYAAACBdR0qAAAABHNCSVQICAgIfAhkiAAAAExJREFUSEtjZCAT1Dz8/59MrVi1MZJr2KhDyA05YvWRHTXEWkCsusHjEGonOmJDAF0d46hD0IJk8KQRcuOU2vqGfohQO5GTHSLD1iEA33weQ/srGoQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangang1.png
// module id = 8C0i
// module chunks = 1